// Lustro backend/apps/characters/progression.py – tylko do wyświetlania paska XP (serwer liczy poziomy).
export function xpTotal(level: number): number {
  const n = Math.max(0, level - 1);
  return 50 * n ** 3 + 150 * n ** 2 + 300 * n;
}
